var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotspot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#262626",
    fillOpacity: 0.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 7.5,
    fill: "#FF6B3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8 13.5C16.8 13.1686 16.5314 12.9 16.2 12.9L14.1 12.9L14.1 10.8C14.1 10.4686 13.8314 10.2 13.5 10.2C13.1686 10.2 12.9 10.4686 12.9 10.8L12.9 12.9L10.8 12.9C10.4686 12.9 10.2 13.1686 10.2 13.5C10.2 13.8314 10.4686 14.1 10.8 14.1L12.9 14.1L12.9 16.2C12.9 16.5314 13.1686 16.8 13.5 16.8C13.8314 16.8 14.1 16.5314 14.1 16.2L14.1 14.1H16.2C16.5314 14.1 16.8 13.8314 16.8 13.5Z",
    fill: "white",
    fillOpacity: 0.86
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotspot);
export default __webpack_public_path__ + "static/media/hotspot.25b29cfd8d540b2931da2056f35f1afc.svg";
export { ForwardRef as ReactComponent };